module.exports = __webpack_public_path__ + "static/media/country_xk.e120d94a.webp";